import React from 'react'
import {SectionMenu} from '../section-menu'

const HowToMenu = ({navigate, location}) => {
  const menuItems = [
    'Add Resource Parameters',
    'Call Service Mock',
    'Clean Up Orphaned Responses',
    'Create Mock From Contract',
    'Create Wildcard Resource',
    'Debug Mock',
    'Inspect Request',
    'Prioritize Mock Resources',
    'Prioritize Mock Responses',
    'Proxy From Real Services',
    'Resolve Mock Contract Conflicts',
    'Script Mock Response Activation',
    'Secure Mock',
    'Setup Your Team',
    'Share Mock Docs Link',
    'Simulate Delay',
    'Template Response'
  ]
  return (
    <SectionMenu pathPrefix='how-to' navigate={navigate} location={location} menuItems={menuItems} path='how-to'/>
  )
}


export {HowToMenu}

export default HowToMenu